import { BlogCardProps } from '@/components/card/types';
import { DescriptionStrapi, ImageStrapiType, MetaStrapi } from '@/strapi-types';
import { getContentHubPath } from '@/utils/get-content-hub-path';

type Category = {
  variant: string;
  title: string;
};

type MapCardType = {
  locale: string;
  type: string;
  createdAt: string;
  duration: string;
  publishedAt: string;
  publishedDate: string;
  slug: string;
  title: string;
  updatedAt: string;
  shortExcerpt: DescriptionStrapi[];
  meta: MetaStrapi;
  categories: Category[];
  mainImage: ImageStrapiType;
};

export function mapCardContentHub(
  contentItem: MapCardType,
  linkTitle: string = 'Mehr lesen',
  artikelTranslation: string = 'Artikel',
): BlogCardProps {
  const { locale, type, title, duration, mainImage, categories, slug } =
    contentItem;

  switch (type) {
    case 'artikel':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'pen-tool',
          },
          title: artikelTranslation,
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Article Image',
          ariaLabel: 'Article Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, type, slug),
          title: linkTitle,
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };
    case 'new':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'newspaper',
          },
          title: 'News',
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Article Image',
          ariaLabel: 'Article Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, 'news', slug),
          title: linkTitle || 'Mehr lesen',
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };
    case 'flash-talk':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'zap',
          },
          title: 'Flash Talk',
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Flash Talk Image',
          ariaLabel: 'Flash Talk Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, 'flash-talk', slug),
          title: linkTitle || 'Mehr lesen',
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };
    case 'edu-talk':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'graduation-cap',
          },
          title: 'Edu Talk',
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Edu Talk Image',
          ariaLabel: 'Edu Talk Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, 'edu-talk', slug),
          title: linkTitle || 'Mehr lesen',
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };
    case 'podcast':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'mic',
          },
          title: 'Podcast',
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Podcast Image',
          ariaLabel: 'Podcast Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, 'podcast', slug),
          title: linkTitle || 'Mehr lesen',
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };
    case 'webinar':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'video',
          },
          title: 'Webinar',
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Webinar Image',
          ariaLabel: 'Webinar Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, 'webinar', slug),
          title: linkTitle || 'Mehr lesen',
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };
    case 'ratgeber':
      return {
        variant: 'blog',
        type: {
          icon: {
            name: 'book-open',
          },
          title: 'Ratgeber',
          duration: duration,
        } as unknown as any,
        title: title,
        image: {
          image: mainImage,
          classNameImage: 'w-full h-full object-top',
          alt: 'Ratgeber Image',
          ariaLabel: 'Ratgeber Image',
        },
        badge: categories?.map((item) => {
          return { variant: item.variant || 'ice-blue', title: item.title };
        }),
        link: {
          href: getContentHubPath(locale, 'ratgeber', slug),
          title: linkTitle || 'Mehr lesen',
          rightIcon: {
            name: 'chevron-right',
          },
        },
      };

    default:
      throw new Error(`Unknown content type: ${type}`);
  }
}
